import { useSelector, useDispatch } from 'react-redux';
import { useMemo } from 'react';
import FJConstant from '../../../constants/FJConstant';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionModal from '../../../redux/action/FJActionModal';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import FJMobilePreviewModal from './FJMobilePreviewModal';
import { setSliceMobileGenerateSuccessPreviewIndex } from '../../../redux/slices/FJSliceCommon';

const FJPreviewModalContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const mobilePreviewData = useSelector(state => state.modals.mobilePreviewData);
    const historyList = useSelector(state => state.common.historyList);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const creationList = useSelector(state => state.common.creationList);
    const { display, data = {}, previewList: list, isShowOrder = true } = mobilePreviewData;
    const { id, type } = data;

    const onClose = () => {
        dispatch(FJActionModal.hidePreviewModalDataAction());
    };
    const onDownload = callback => {
        dispatch(FJActionCommon.multiDownloadAction([id], 'preview', callback));
    };
    const onDelete = () => {
        let index = previewList.findIndex(item => item.id === id);
        dispatch(
            FJActionCommon.multiDeleteAction([id], list => {
                if (!list) return;
                if (!list.length) {
                    onClose();
                    return;
                }
                index >= list.length && (index = list.length - 1);
                previewImage(list[index]);
            }),
        );
    };

    const shareToSociety = type => {
        dispatch(FJActionModal.shareToSocietyAction(id, type));
    };
    const previewImage = data => {
        dispatch(FJActionModal.showPreviewModalDataAction({ ...mobilePreviewData, data }));
    };
    const previewList = useMemo(() => {
        if (list && list.length) {
            return list;
        } else if (type === FJConstant.HISTORY) {
            return historyList;
        } else {
            return creationList;
        }
    }, [type, historyList, creationList, list]);
    const switchPreview = (isNext = true) => {
        const index = previewList.findIndex(item => item.id === id);
        const nextIndex = isNext ? index + 1 : index - 1;
        if (previewList[nextIndex]) {
            previewImage(previewList[nextIndex]);
            if (taskStatus === FJConstant.SUCCESS) {
                dispatch(setSliceMobileGenerateSuccessPreviewIndex(nextIndex));
            }
        }
    };

    return (
        <FJMobilePreviewModal
            visible={display}
            shareToSociety={shareToSociety}
            onClose={onClose}
            data={data}
            onDownload={onDownload}
            onDelete={onDelete}
            switchPreview={switchPreview}
            previewList={previewList}
            isShowOrder={isShowOrder}
        />
    );
};
export default FJPreviewModalContainer;
